import { z } from 'zod'
import type { MetricCategory } from '#/domain/catalog/MetricCategory'
import type { MetricCategoryDto as MetricCategoryDtoSpec } from '#/infrastructure/api/generated'
import type { Assert, SpecContract } from '#/infrastructure/api/SpecContract'

export const MetricCategoryDtoSchema = z
  .object({
    Id: z.string(),
    Displayname: z.string(),
    DisplayOrder: z.number(),
  })
  .transform((raw): MetricCategory => ({
    Id: raw.Id,
    DisplayName: raw.Displayname,
    DisplayOrder: raw.DisplayOrder,
  }))

export type MetricCategoryResponseDto = z.input<typeof MetricCategoryDtoSchema>
export type MetricCategoryDtoSpecContract = Assert<
  SpecContract<MetricCategoryResponseDto, MetricCategoryDtoSpec>
>

export function toDomain(raw: MetricCategoryResponseDto): MetricCategory {
  return MetricCategoryDtoSchema.parse(raw)
}

export function toDomainList(raw: MetricCategoryResponseDto[]): MetricCategory[] {
  return raw.map(toDomain)
}
